import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18Star1 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "m8.836 4.253 1.32 2.22c.196.32.514.543.88.62l2.52.52-1.74 1.92a1.36 1.36 0 0 0-.32 1l.29 2.55-2.36-1a1.34 1.34 0 0 0-1.09.01l-2.34 1.11.24-2.57a1.33 1.33 0 0 0-.35-1l-1.74-1.92 2.51-.57a1.3 1.3 0 0 0 .87-.61l1.27-2.28m-.06-2.25a.14.14 0 0 0-.12.08l-2.13 3.82a.13.13 0 0 1-.09.07l-4.29 1a.14.14 0 0 0-.07.23l3 3.25a.12.12 0 0 1 0 .1l-.4 4.38a.14.14 0 0 0 .14.16h.06l4-1.82h.11l4 1.74h.05a.14.14 0 0 0 .14-.16l-.4-4.41a.11.11 0 0 1 0-.11l2.9-3.3a.14.14 0 0 0-.08-.23l-4.32-.88a.13.13 0 0 1-.09-.07l-2.25-3.78a.15.15 0 0 0-.16-.07"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Star1$1 = Svg18Star1;

export { Svg18Star1$1 as default };
